import React from 'react';
export function Footer() {
  return <footer className="bg-forest-dark py-8 border-t border-forest-light text-center px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-cream-dark text-sm" data-id="element-125">
          © 2026 Mega Pack Educación Agropecuaria en el Aula — Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}